module.exports = __webpack_public_path__ + "static/media/banner.47890885.svg";